import { render, staticRenderFns } from "./word-manager.vue?vue&type=template&id=6a5388d5&scoped=true"
import script from "./word-manager.ts?vue&type=script&lang=ts&external"
export * from "./word-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./word-manager.less?vue&type=style&index=0&id=6a5388d5&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5388d5",
  null
  
)

export default component.exports